// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as TasksComponent} from './Tasks.svg';

import Icon, { TIconProps } from '../Icon';

export const IconTasks = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <TasksComponent/>
  </Icon>
));
